export default __webpack_public_path__ + "static/media/FAQ_13_3.b5312aa5.png";